import { IPaginationConfig } from './Pagination.interfaces';

export function getPaginationLabels (config: IPaginationConfig): string[] {
    const {
        currentPage,
        totalPages,
        separator,
        deviceOption: {
            pageLimit,
            maxAllowedPerSide,
        },
    }: IPaginationConfig = config;

    if (totalPages <= 0) {
        throw new Error('Total pages must be greater than 0');
    }

    if (currentPage > totalPages) {
        throw new Error('Current page must not be greater than the total pages value');
    }

    const allPages: string[] = Array.from(
        { length: totalPages },
        (_, i): string => {
            return (i + 1).toString();
        });

    let pagesToRemove: number = allPages.length - pageLimit;

    if (pagesToRemove <= 0) {
        return allPages;
    }

    const indexDiff: number = 1;
    const startPageOffset: number = 1;
    const leftSideCount: number = currentPage - indexDiff - startPageOffset;
    const shouldTruncateLeftSide: boolean = leftSideCount > maxAllowedPerSide;

    if (shouldTruncateLeftSide) {
        const start: number = 1;
        const deleteCount: number = leftSideCount - maxAllowedPerSide;

        allPages.splice(start, Math.min(deleteCount, pagesToRemove), separator);
        pagesToRemove -= deleteCount;
    }

    const shouldTruncateRightSide: boolean = pagesToRemove > 0;

    if (shouldTruncateRightSide) {
        const start: number = allPages.length - pagesToRemove - indexDiff;

        allPages.splice(start, pagesToRemove, separator);
    }

    return allPages;
}
